interface Language extends Record<string, string|null> {

}
interface Translations extends Record<string, Language> {

}

const TRANSLATIONS: Translations = {
    'en': {
        'Download': null,
        'Trash': null,
        'Email Link': null,
        'Copy Link': null,
        'Share with contact': null,
        'Archive': null,
        'Unarchive': null,
        'Rename': null,
        'item': null,
        'items': null,
        'Expires in': null,
        'Onetime free transfer bonus.': null,
        'Thank you for using Arcano! You have reached your 3 free transfers this month, this one time the next 5 are a little thank-you gift from us.': null,
        'Get 5 free transfers now': null,
        'Transfer-limit exceeded, please contact the website-host!': null,
        'This user has reached their Arcano Client transfer-limit. Please contact him to ensure your file can be transferred safely.': null,
        'No more transfers!': null,
        'You have reached your monthly transfer-limit for Arcano Client, please subscribe to transfer as many files as you want.': null,
        'Add contact': null,
        'No contacts found': null,
        'You can only add users that have enabled to be found': 'You can only add users if you know the exact e-mail address',
        'Add': 'Add',
        'Delete': 'Remove',
        'If you remove a contact, the files received from this person will be shown as Anonymous': null,
        'Downloaded': null,
        'Sent': null,
    },
    'de': {
        'Download': 'Download',
        'Trash': 'Löschen',
        'Email Link': 'Email Link',
        'Copy Link': 'Link kopieren',
        'Share with contact': 'Mit Kontakt teilen',
        'Archive': 'Archivieren',
        'Unarchive': 'Aus Archiv entfernen',
        'Rename': 'Name ändern',
        'item': 'Element',
        'items': 'Elemente',
        'Expires in': 'Läuft ab in',
        'Onetime free transfer bonus.':'Einmalige bonus Transfers!',
        'Thank you for using Arcano! You have reached your 3 free transfers this month, this one time the next 5 are a little thank-you gift from us.':'Vielen Dank, dass Sie Arcano nutzen! Sie haben Ihr Limit von 3 gratis Transfers im Monat erreicht, doch als kleines Dankeschön erhöhen wir ihr Limit einmalig um 5 weitere Transfers.',
        'Get 5 free transfers now':'Jetzt einmalig 5 gratis Transfers erhalten',
        'Transfer-limit exceeded, please contact the website-host!':'Die Transfer-limite wurde erreicht, kontaktieren Sie den Website host',
        'This user has reached their Arcano Client transfer-limit. Please contact him to ensure your file can be transferred safely.':'Dieser Nutzer hat das Limit seiner gratis Arcano-Transfers erreicht. Bitte kontaktieren Sie ihn um sicherzustellen, dass Ihre Dateien sicher versendet werden können',
        'No more transfers!':'Keine Transfers mehr!',
        'You have reached your monthly transfer-limit for Arcano Client, please subscribe to transfer as many files as you want.':'Sie haben das Limit Ihrer monatlichen gratis Arcano-Transfers erreicht, bitte lösen Sie ein Abonnement um unlimitiert viele Transfers zu versenden',
        'Add contact': 'Kontakt hinzufügen',
        'No contacts found': 'Keinen Kontakt gefunden',
        'You can only add users that have enabled to be found': 'Sie können nur Benutzer hinzufügen, wenn Sie die genaue E-Mail Addresse kennen',
        'Add': 'Add',
        'Delete': 'Entfernen',
        'If you remove a contact, the files received from this person will be shown as Anonymous': 'Wenn Sie einen Kontakt entfernen, werden die von dieser Person empfangenen Dateien als Anonym angezeigt',
        'Downloaded': 'Heruntergeladen',
        'Sent': 'Gesendet',
    },
    'fr': {
        'Download': 'Download',
        'Trash': 'Effacer',
        'Email Link': 'Email lien',
        'Copy Link': 'Copier le lien',
        'Share with contact': 'Partager avec un conatct',
        'Archive': 'Archiver',
        'Unarchive': 'Désarchiver',
        'Rename': 'Renommer',
        'item': 'élément',
        'items': 'éléments',
        'Expires in': 'Expire dans',
        'Onetime free transfer bonus.': 'Bonusransfert gratuit',
        'Thank you for using Arcano! You have reached your 3 free transfers this month, this one time the next 5 are a little thank-you gift from us.':'Merci d\'utiliser Arcano ! Vous avez atteint vos 3 transferts gratuits ce mois-ci, cette fois-ci les 5 prochains sont un petit cadeau de remerciement de notre part.',
        'Get 5 free transfers now':'Obtenez 5 transferts gratuits maintenant',
        'Transfer-limit exceeded, please contact the website-host!':'',
        'This user has reached their Arcano Client transfer-limit. Please contact him to ensure your file can be transferred safely.':'',
        'No more transfers!':'',
        'You have reached your monthly transfer-limit for Arcano Client, please subscribe to transfer as many files as you want.':'',
        'Add contact': 'Ajouter un contact',
        'No contacts found': 'Aucun contact trouvé',
        'You can only add users that have enabled to be found': 'Vous ne pouvez ajouter que des utilisateurs qui ont permis d\'être trouvés.',
        'Add': 'Add',
        'Delete': 'Enlever',
        'If you remove a contact, the files received from this person will be shown as Anonymous': 'Si vous supprimez un contact, les fichiers reçus de cette personne seront affichés comme anonymes',
        'Downloaded': 'Téléchargé',
        'Sent': 'Envoyé',
    }
}

function getLocale(): string {
    if (window.location.pathname.includes('/de/')) {
        return 'de'
    }
    if (window.location.pathname.includes('/fr/')) {
        return 'fr'
    }
    return 'en'
}


export function translate(text: string): string {
    let locale = getLocale()
    let t = TRANSLATIONS[locale];
    if (text in t) {
        const s = t[text];
        if(s) {
            return s;
        }
    }
    return text;
}

export function localizeSecret(secret: string): string {
    let url = new URL(secret)
    const locale = getLocale()
    url.pathname = ('/' + locale + '/' + url.pathname).replace('//', '/')
    return url.href
}

export function getCurrentLang(): string {
    return getLocale()
}